import requestPasswordReset from 'src/dataLayer/remoteData/babbelAPI/requestPasswordReset';
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData';
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';

export default function useResetPasswordRequest({ captchaResponseToken, email }) {
    const { locale } = useRouteParamsContext();
    const {
        data,
        makeRequest,
        inProgress
    } = useAsyncData(() => requestPasswordReset({ captchaResponseToken, email, locale }));

    return {
        resetPasswordRequest: data || null,
        makeResetPasswordRequest: makeRequest,
        isResetPasswordRequestInProgress: inProgress
    };
};
